import type { BrandKitField } from "@/types/onboarding";

const groupFieldsByCategory = (fields: BrandKitField[]) => {
  return fields.reduce(
    (groups, field) => {
      const categoryDsKey = field.category?.dsKey;
      if (categoryDsKey) {
        if (!groups[categoryDsKey]) {
          groups[categoryDsKey] = [];
        }
        groups[categoryDsKey].push(field);
      }
      return groups;
    },
    {} as Record<string, BrandKitField[]>,
  );
};

const arrayFieldsToDataSources = (fields: BrandKitField[]) => {
  const output: Record<string, Record<string, string | null>[]> = {};
  const fieldGroups = groupFieldsByCategory(fields);
  Object.keys(fieldGroups).forEach((fieldGroupKey) => {
    output[fieldGroupKey] = [];
  });
  return output;
};

const fieldsToDataSources = (fields: BrandKitField[]) => {
  const output: Record<string, string> = {};
  const arrayFields: BrandKitField[] = [];
  // const groupedFields: Record<string, Record<string, string>> = {};
  fields.forEach((field) => {
    const fieldDsKey = field.dsKey || field.id;
    if (field.id.includes("[i]")) {
      arrayFields.push(field);
    } else {
      const units =
        field.field && typeof field.field === "object" && "units" in field.field
          ? (field.field as { units?: string[] }).units
          : undefined;
      const value =
        units && units.length > 0
          ? `${String(field.value)}${units[0]}`
          : String(field.value);
      output[fieldDsKey] = value;
    }
  });
  return {
    ...output,
    ...arrayFieldsToDataSources(arrayFields),
  };
};

export default fieldsToDataSources;
